<template lang="html">
  <img class="" src="@/assets/logo.svg" alt="logo" width="250" />
  <h1 class="p-0">Bedankt!</h1>
  <h2>Scan de QR code op de grijpmachine en start het spel.</h2>
  <h2>Succes!</h2>
  <div class="center">
    <img
      :src="'https://clawmachine.nl/qrcode/?s=qr&sf=8&d=' + getSavedDataId"
      width="250"
    />
  </div>
  <button
    type="button"
    class="btn btn-secondary btn-lg rounded-0"
    @click="goToUrl()"
  >
    <span>Naar Rodi</span>
  </button>
</template>

<script>
export default {
  name: "QrCodeScreen",
  data: () => ({}),
  computed: {
    getSavedDataId: function () {
      let savedData = this.$store.getters.getSavedData;
      if (savedData !== null) {
        return savedData._id;
      }
      return false;
    },
  },
  methods: {
    goToUrl() {
      window.location.href = "https://www.rodi.nl";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
h1 {
  font-size: 30px;
  color: $primary;
}
h2 {
  font-size: 25px;
  color: $primary;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  width: 90%;
  padding: 10px;
  font-size: 40px;
  border-radius: 0px;
  text-align: center;
  margin-bottom: 20px;
}
.center {
  text-align: center;
}
</style>
